<template>
  <div>
    <d-container fluid class="main-content-container px-4 pb-4">
      <!-- Page Header -->
      <d-row no-gutters class="page-header py-4">
        <!-- Page Title -->
        <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
          <span class="text-uppercase page-subtitle">{{ getCurrentCampaign.name }}</span>
          <h3 class="page-title">{{ $t("campaigns.companies") }}</h3>
        </d-col>
      </d-row>
      <!-- Next Step -->

      <!-- Table -->
      <d-card>
        <d-card-body>
          <d-row class="py-2">
            <!-- Showing Percentage Progress -->
            <span class="w-100 pl-3">
              <!-- <d-link to="/campaigns">
              <d-button class="outline form-back-btn">Back</d-button>
              </d-link>-->
              <d-button
                size="sm"
                class="btn-accent btn-form-end ml-auto d-table mr-3"
                @click="searchContacts()"
                :disabled="isCampaignLoading || !Object.keys(this.selectedCompanies)
                .map(id => (this.selectedCompanies[id] ? id : null))
                .filter(Boolean).length"
              >
                <!-- TODO: Add i18n to Search -->
                <i class="material-icons"></i>
                {{ isCampaignLoading ? "Loading..." : "Search Contacts" }}
              </d-button>
            </span>
          </d-row>

          <div class="float-right">
            <span class="font-weight-bold">
              {{ Object.keys(this.selectedCompanies)
              .map(id => (this.selectedCompanies[id] ? id : null))
              .filter(Boolean).length }}
            </span>
            {{ $t("campaigns.companiesselected") }}
          </div>

          <div class="pt-2 mb-3" />

          <!-- /Table Tabs -->
          <v-client-table
            :data="companies"
            :columns="columns"
            :options="clientTableOptions"
            class="dataTables_wrapper file-manager file-manager-list"
          >
            <div slot="select" slot-scope="props">
              <div class="custom-control custom-checkbox">
                <input
                  v-model="selectedCompanies[props.row._id]"
                  type="checkbox"
                  class="custom-control-input"
                  v-bind:id="props.row._id"
                />
                <label class="custom-control-label" :for="`${props.row._id}`"></label>
              </div>
            </div>

            <!-- Item Icon Slot -->
            <div slot="icon" slot-scope="props" class="file-manager__item-icon">
              <div>
                <img
                  v-if="props.row.dataSourceResponse.logo"
                  class="company-avatar rounded-circle mr-2"
                  :src="props.row.dataSourceResponse.logo"
                  alt
                />
                <img v-else class="company-avatar rounded-circle mr-2" alt />
              </div>
            </div>

            <!-- Name Column -->
            <div slot="name" slot-scope="props" class="text-left">
              <div class="prospects-role">{{ props.row.name }}</div>
            </div>
            <div slot="description" slot-scope="props" class="text-left">
              <div class="prospects-company">{{ props.row.dataSourceResponse.description }}</div>
            </div>

            <!-- Website -->
            <div
              slot="website"
              slot-scope="props"
            >{{ props.row.dataSourceResponse.website || 'N/A'}}</div>

            <d-button-group
              slot="website"
              slot-scope="props"
              size="small"
              class="d-flex justify-content-center"
            >
              <d-button
                target="_blank"
                class="icon-yellow btn-white"
                @click="openCompanyUrl(props.row.dataSourceResponse.domain)"
                :disabled="!props.row.dataSourceResponse.domain"
                v-d-tooltip.hover="$t('company.tooltipwebsite')"
              >
                <i class="icon-yellow material-icons">link</i>
              </d-button>
            </d-button-group>

            <!-- Industry Column -->
            <div
              slot="industry"
              slot-scope="props"
            >{{ props.row.dataSourceResponse.category ? props.row.dataSourceResponse.category.industry || 'N/A' : ""}}</div>

            <!-- Social Column -->
            <div slot="social" slot-scope="props">
              <a
                v-if="props.row.dataSourceResponse.linkedin.handle"
                :href="`https://www.linkedin.com/${props.row.dataSourceResponse.linkedin.handle}`"
                target="_blank"
              >
                <img src="@/assets/images/linkedin_small_icon.png" alt="linkedin icon" width="40" />
              </a>
            </div>

            <!-- Actions Column Slot -->
            <!-- <d-button-group
            slot="blacklist"
            slot-scope="props"
            size="small"
            class="d-flex justify-content-center"
          >
            <d-button
              class="icon-green btn-white unfilled"
              @click="handleActionClick('accept', props.row.id)"
              v-d-tooltip.hover="'Accept'"
            >
              <i class="icon-green material-icons unfilled">&#xe8dc;</i>
            </d-button>

            <d-button
              class="icon-red btn-white unfilled"
              @click="handleActionClick('reject', props.row.id)"
              v-d-tooltip.hover="'Reject'"
            >
              <i class="icon-red material-icons unfilled">&#xe15c;</i>
            </d-button>

            <d-button
              class="icon-black btn-white font-weight-bolder unfilled"
              @click="handleActionClick('blacklist', props.row._id)"
              v-d-tooltip.hover="'Blacklist'"
            >
              <i class="icon-black material-icons unfilled">&#xe14b;</i>
            </d-button>
            </d-button-group>-->
            <!-- Location Column -->
            <div
              slot="location"
              slot-scope="props"
            >{{ props.row.dataSourceResponse.geo ? `${props.row.dataSourceResponse.geo.city}, ${props.row.dataSourceResponse.geo.stateCode} ${props.row.dataSourceResponse.geo.countryCode}` : 'N/A'}}</div>
          </v-client-table>
        </d-card-body>
      </d-card>
    </d-container>
  </div>
</template>

<script>
import Vue from "vue";
import { ClientTable } from "vue-tables-2";

import "@/assets/scss/vue-tables.scss";
import "@/assets/scss/file-manager-list.scss";

const ListCount = "12";

Vue.use(ClientTable);

import _ from "lodash";
import { mapGetters } from "vuex";
import { CAMPAIGN_GET, CAMPAIGN_SEARCH_CONTACTS } from "@/store/types";

export default {
  components: {
    ClientTable
  },
  computed: {
    ...mapGetters(["getCurrentCampaign", "isCampaignLoading"]),
    companies() {
      if (
        this.getCurrentCampaign &&
        this.getCurrentCampaign.companySearchResults
      ) {
        return this.getCurrentCampaign.companySearchResults;
      } else {
        return [];
      }
    }
  },
  mounted() {
    if (this.getCurrentCampaign) {
      console.log(this.getCurrentCampaign);
    } else {
      // If reloading the page
      this.$store.dispatch(CAMPAIGN_GET, this.$route.params.id);
    }
  },
  destroyed() {
    if (this.$route.name !== "template-editor") {
      this.$store.commit(CAMPAIGN_GET, null);
    }
  },
  data() {
    return {
      selectedCompanies: {},
      tabSelected: undefined,
      // tableTabs: [
      //   { id: 1, tabName: "New", amount: "149" },
      //   { id: 2, tabName: "Sent", amount: "48" }
      //   // { id: 3, tabName: "Accepted", amount: "48" },
      //   // { id: 4, tabName: "Rejected", amount: "3" },
      //   // { id: 5, tabName: "Blacklisted", amount: "1" }
      // ],
      columns: [
        "select",
        "icon",
        "name",
        "description",
        "website",
        "social",
        "industry",
        // "blacklist",
        "location"
      ],
      /**
       * Vue Tables Configuration Options
       * @see https://github.com/matfish2/vue-tables-2
       */
      clientTableOptions: {
        perPage: 10,
        recordsPerPage: [10, 25, 50, 100],
        skin: "file-manager file-manager-list table dataTable",
        sortIcon: {
          base: "fas float-right mt-1 text-muted",
          up: "fa-caret-up",
          down: "fa-caret-down"
        },
        texts: {
          filterPlaceholder: "",
          limit: "Show"
        },
        pagination: {
          edge: true,
          nav: "scroll"
        }
      }
    };
  },
  methods: {
    async searchContacts() {
      const selected = Object.keys(this.selectedCompanies)
        .map(id => (this.selectedCompanies[id] ? id : null))
        .filter(Boolean);

      try {
        await this.$store.dispatch(CAMPAIGN_SEARCH_CONTACTS, selected);

        this.selectedCompanies = {};
        this.$router.push({
          name: "campaign-prospects",
          params: { id: this.getCurrentCampaign._id }
        });
      } catch (err) {
        console.log(err);
        if (err.response.status === 404) {
          this.errorMessage = this.$t("company.error.contactnotfound");
        }
      }
    },
    handleActionClick(action, id) {
      const message = action === "edit" ? "Editing" : "Deleting";
      alert(`${message} item ${id}`); // eslint-disable-line no-alert
    },
    openCompanyUrl(domain) {
      if (!domain) {
        return;
      }
      window.open(`http://${domain}`, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
tr td {
  min-width: 120px !important;
}
th {
  display: inline !important;
}
.custom-control-label::before {
  border: 1px solid #007bff !important;
  width: 22px;
  height: 22px;
  padding: 10px !important;
}
.custom-control-label::after {
  margin: 2px 1px;
  padding: 2px;
}

.custom-control {
  margin-top: -2px;
}
</style> 